export enum LearningResourceStatus {
    NotStarted,
    Started,
    Completed
}